import { createSelector } from 'reselect';
import { getIsUngatedForPresets, getIsUngatedForPresetsInUniversalThemeEditor } from './authSelectors';
import { getThemePath } from './themeSelectors';
const getIsUniversalThemeEditing = (state, props) => props.isUniversalThemeEditing;
export const getHasThemePresetsAccess = createSelector([getIsUngatedForPresets, getIsUniversalThemeEditing, getIsUngatedForPresetsInUniversalThemeEditor, getThemePath], (isUngatedForPresets, isUniversalThemeEditing, isUngatedForPresetsInUniversalThemeEditor, themePath) => isUngatedForPresets && (!isUniversalThemeEditing || isUngatedForPresetsInUniversalThemeEditor) && themePath === '@hubspot/elevate' // TODO: remove this once other themes support presets
);
export const getPresets = state => state.presets.presetsById;
export const getPresetsRequestStatus = state => state.presets.requestStatus;
export const getActiveThemePresetId = state => {
  var _state$presets;
  return (_state$presets = state.presets) === null || _state$presets === void 0 ? void 0 : _state$presets.activeThemePresetId;
};
export const getSelectedThemePresetId = state => {
  var _state$presets2;
  return (_state$presets2 = state.presets) === null || _state$presets2 === void 0 ? void 0 : _state$presets2.selectedThemePresetId;
};
export const getSetActiveThemePresetRequestStatus = state => state.presets.setActiveThemePresetRequestStatus;
export const getPresetsAsArray = state => Object.values(state.presets.presetsById);
export const getPresetById = (state, id) => state.presets.presetsById[id];
export const getActiveThemePresetStyles = state => {
  var _getPresetById;
  const activeThemePresetId = getActiveThemePresetId(state);
  return activeThemePresetId !== undefined ? (_getPresetById = getPresetById(state, activeThemePresetId)) === null || _getPresetById === void 0 ? void 0 : _getPresetById.styles : undefined;
};